/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

// prettifies a number by showing up to n decimal points (if needed) and adds % symbol
export const formatPercentage = (numberOrString: number | string, decimalPlaces: number = 2): string => {
  const num = typeof numberOrString === 'string' ? Number(numberOrString) : numberOrString;
  if (decimalPlaces === 0) return `${Math.round(num)}%`;
  return `${num.toFixed(decimalPlaces).replace(/\.?0+$/, '')}%`;
};
